import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IYachtData } from '../../ApiCalls';
import { LocalStorage } from '../../LocalStorage';

export interface ISelectedYachtState {
  currencies: string[];
  yacht: IYachtData | null;
};

const initialState: ISelectedYachtState = {
  currencies: LocalStorage.yachtCurrencies,
  yacht: LocalStorage.yacht,
};

export const selectedYachtSlice = createSlice({
  name: 'selectedYacht',
  initialState,
  reducers: {
    selectYacht: (state, action: PayloadAction<IYachtData | null>) => {
      state.yacht = action.payload;
    },
    selectYachtCurrencies: (state, action: PayloadAction<string[]>) => {
      state.currencies = action.payload;
    },
  },
});

export const { selectYacht, selectYachtCurrencies } = selectedYachtSlice.actions;
export const selectedYachtState = (state: RootState) => state.selectedYacht.yacht;
export const selectedYachtCurrenciesState = (state: RootState) => state.selectedYacht.currencies;

export default selectedYachtSlice.reducer;
